import { render } from "./NothingFoundMessage.vue?vue&type=template&id=1a807686"
import script from "./NothingFoundMessage.vue?vue&type=script&lang=js"
export * from "./NothingFoundMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__